import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://rdzdujkzuuoersnukikq.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJkemR1amt6dXVvZXJzbnVraWtxIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTczODM1NjUyMSwiZXhwIjoyMDUzOTMyNTIxfQ.n8k3_62EAomNZxCAWpbDxWC_Iybe50D9gY3UGrUZ9jI';

export const supabase = createClient(supabaseUrl, supabaseKey);